/**
 * Когда показывать инстрим-брендинг (и баннер-уголок) за один просмотр.
 *
 * Правила (договорённость с sports.ru, 10.2026):
 * - видео до 30 секунд включительно: не показываем;
 * - 30-60 секунд: один показ на 8-10-й секунде;
 * - 60-120 секунд: на 12-15-й секунде;
 * - длиннее 120 секунд, трансляции и каналы: на 15-20-й секунде.
 * Показ один за просмотр, повторов нет.
 *
 * @param {object} params
 * @param {number} [params.duration] длительность видео в секундах
 * @param {boolean} [params.isLive] трансляция или канал (длительность неизвестна)
 * @param {function} [params.random] источник случайности 0..1 (для тестов)
 * @returns {number|null|undefined} секунда просмотра для показа; null, если не
 *   показываем; undefined, если длительность видео ещё не известна
 */
const NO_BRANDING_MAX_DURATION = 30;

const RANGES = [
  { maxDuration: 60, from: 8, to: 10 },
  { maxDuration: 120, from: 12, to: 15 },
  { maxDuration: Infinity, from: 15, to: 20 },
];

function pick({ from, to }, random) {
  return from + Math.floor(random() * (to - from + 1));
}

export default function getBrandingStartSecond({
  duration,
  isLive = false,
  random = Math.random,
} = {}) {
  if (isLive) {
    return pick(RANGES[RANGES.length - 1], random);
  }

  if (!Number.isFinite(duration) || duration <= 0) {
    return undefined;
  }

  if (duration <= NO_BRANDING_MAX_DURATION) {
    return null;
  }

  return pick(
    RANGES.find((range) => duration <= range.maxDuration),
    random
  );
}

/**
 * Корзина длительности для отчётов по инвентарю брендинга (параметр событий
 * branding_* в Метрике и GA4). undefined, пока длительность видео не известна.
 */
export function getBrandingDurationBucket({ duration, isLive = false } = {}) {
  if (isLive) return "live";
  if (!Number.isFinite(duration) || duration <= 0) return undefined;
  if (duration <= NO_BRANDING_MAX_DURATION) return "le30";
  if (duration <= 60) return "30_60";
  if (duration <= 120) return "60_120";
  return "gt120";
}
